import { observable } from "mobx";
import { Type } from "class-transformer";
import ChargeOverlapResponse from "./chargeOverlapResponse";
import ChargeOverlapType from "./chargeOverlapType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ProposedChargeValidityResponse {
  /**
   * Calculated proposed valid since based on requested validity and charge overlaps.
   */
  @observable
  @Type(() => Date)
  validSince!: Date;

  /**
   * Calculated valid until based on requested validity and charge overlaps.
   */
  @observable
  @Type(() => Date)
  validUntil!: Date;

  /**
   * Existing overlapping charges for proposed validity - max 3 most relevant overlaps.
   */
  @observable
  @Type(() => ChargeOverlapResponse)
  overlappingCharges?: ChargeOverlapResponse[];

  /**
   * Charge overlaps for proposed validity.
   */
  @observable
  overlapTypes?: ChargeOverlapType[];
}
